<p-dialog class="user-admin-dialog" [(visible)]="isOpen" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'" [styleClass]="'contextMenuModal profileModal user-admin-dialog'"
  [closable]="false" [dismissableMask]="true" [baseZIndex]="10000" [closeOnEscape]="true" [style]="{'height':'740px','max-width':'1350px', 'width': '70%'}"
  [resizable]="false">
  <p-header>

    <div class="d-flex flex-row align-items-center justify-content-between  mx-2 mt-1">
      <h6 class="reage-title">User Group Assignment</h6>
      <button type="button" (click)="closeModal()" class="d-flex flex-row closebtn ">
        <img src="assets/qwyn/icons/close-white.svg" alt="Close">
      </button>
    </div>
  </p-header>
  <div class="gfid-body admin-gfid-padding">
    <ng-template #customLoadingTemplate>
      <div class="custom-class-loader">
        <div class="spinner-container">
          <img src="assets/qwyn/icons/spinner.gif" alt="Loading" class="loader">
        </div>
      </div>
    </ng-template>
    <ngx-loading [show]="showSpinner" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate">
    </ngx-loading>

    <div class="w-80">
      <p-tabView class="adminview userGroupAssignment" id='profileTabs' #profileTabs (onChange)="onTabChange($event)" [styleClass]="'user-admin-tabview'"
        [scrollable]="false" [style]="{'height':'595px','width':'95%','max-width':'1200px',overflow: 'hidden', 'position': 'relative'}"
        [activeIndex]="actTabIdx">
       
          <!-- Search by SOEID start -->
          <div class="propertyWrap">
            <div class="w-20 d-flex flex-row align-items-start ">
              <label for="from" class="flex-grow label_font">User ID: </label>
              <span class="d-flex" style="width:330px;margin-left: 118px; ">
                <input type="text" style="max-width: 100%;" (keydown)="callLookupSercive($event)" [(ngModel)]="newUserSoeid" #soeId [ngModelOptions]="{standalone: true}" 
                placeholder="Search..." class="w-50 search-box"  />
                <img
                  (click)="callLookupSercive($event)"
                  src="assets/Inbox/search_secondary_column.svg"
                  alt="Search"
                  width="21"
                  height="21"
                  class="search-icon"
                />
                <!-- <span *ngIf="newUserSoeid && !userNotFound" class="clear-icon fa fa-times" (click)="clearSoeid()"></span>
                <span *ngIf="newUserSoeid && userNotFound" class="clear-icon fa fa-times" (click)="clearSoeid()"></span> -->
              </span>
            </div>
            <!--Search Error message -->
            <div style="margin-left: 130px;">
              <span *ngIf="notFound"
                   style="color: red; font-size: 14px; padding-top:10px; font-style: italic">{{validationError}}</span>
             <span *ngIf="newUserSoeIdValidationFlag"
                  style="color: red;font-size: 14px;padding-top:10px; font-style: italic">{{blankStringValidationMsg}}
              </span> 
            </div> 
          </div>
          <!-- Search by SOEID Ends -->
        
          <ng-container *ngIf="userNotFound">
            <div class="d-flex flex-row propertyWrap">
              <div class="w-20 d-flex flex-row align-items-start ">
                <label for="from" class="flex-grow label_font">Name: </label>
                <span style="width:330px;margin-left: 126px;">
                        <input type="text" style="max-width: 100%;" #name="ngModel" [(ngModel)]="userDetails.userName" readonly
                        [ngModelOptions]="{standalone: true}"  class="w-50 search-box"
                        />
                  </span>
              </div>


            </div>
            
            <div class="d-flex flex-row propertyWrap">
              <div class="w-20 d-flex flex-row align-items-start ">
                <label for="from" class="flex-grow label_font">Role: </label>
                <span style="width:330px;margin-left: 138px;">
                  <p-dropdown [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'" 
                    [(ngModel)]="selectedRole" [ngModelOptions]="{standalone: true}" (onChange)="groupChangesForInit($event.value)" [options]="userGroupRoleListData"
                    [ngClass]="{'signatureDropdown-open': isDropdownOpen}" (onShow)="isDropdownOpen = true"
                    (onHide)="isDropdownOpen = false">
                  </p-dropdown>
                </span>
              </div>


            </div>

            <div class="p-2 picklistWrap">
              <p-pickList [source]="allGroupDisplayList" [target]="userGroupDisplayList" sourceHeader="Available User Groups" targetHeader="Selected User Groups"
                [responsive]="true" dragdrop="true"  [sourceStyle]="{'height':'200px'}" [targetStyle]="{'height':'200px'}" [showSourceControls]="false" [showTargetControls]="false"  [styleClass]="'picklistStyle'">
                <ng-template let-item pTemplate="item">
                  <div class="ui-helper-clearfix">
                    <span>{{item}}</span>
                  </div>
                </ng-template>
              </p-pickList>
            </div>

          </ng-container>
        <p-footer class="fix-footer">
          <div class="d-flex flex-row flex-wrap px-3 pb-2 pt-3 justify-content-end">
            <button class="btn  me-4 cancel-btn" (click)="reset()">Reset</button>
            <button type="submit" class="btn  submmit-btn" (click)="saveGroupUserAdminDataToDB()">Submit</button>
          </div>
        </p-footer>
      </p-tabView>
    </div>
  </div>
  <p-toast></p-toast>
</p-dialog>
<!-- for sucess message -->
<p-dialog [(visible)]="displaySuccess" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'" [styleClass]="'contextMenuModal successModal ModelClose'"
  [closable]="true" [dismissableMask]="true" [baseZIndex]="10000" [closeOnEscape]="true" [style]="{width: '30%'}">
  <p-header>
    <div class="d-flex flex-row align-items-center justify-content-between">
      <h6 class="success-title">Success Confirmation</h6>
    </div>
  </p-header>
  <div class="success-msg">{{successMessage}}</div>
</p-dialog>
<!--for error message-->
<p-dialog [(visible)]="errorMessage" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'" [styleClass]="'contextMenuModal failureModal ModelClose'"
  [closable]="true" [dismissableMask]="true" [baseZIndex]="10000" [closeOnEscape]="true" [style]="{width: '30%'}">
  <p-header>
    <div class="d-flex flex-row align-items-center justify-content-between">
      <h6 class="success-title">Information</h6>
    </div>
  </p-header>
  <div class="success-msg">{{errorMessage}}</div>
</p-dialog>